import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import cx from 'classnames';
import { getTranslation } from '../../utils/functions';
import { TEXT_TYPES } from '../../constants/formElements';

const addMarginBottom = (type, theme, isMobileView) => {
  switch (type) {
    case TEXT_TYPES.SECTION_TEXT:
      return isMobileView
        ? theme.custom.formText.marginBottomForSubSection
        : theme.custom.formText.marginBottomForSection;
    case TEXT_TYPES.SECTION_HEADER:
      return theme.custom.formText.marginBottomForSubSection;
    default:
      return theme.custom.formText.marginBottomForSection;
  }
};

const addFontWeight = (type) => {
  switch (type) {
    case TEXT_TYPES.SECTION_TEXT:
      return 500;
    default:
      return 400;
  }
};

const addFontSize = (type, theme, isMobileView) => {
  switch (type) {
    case TEXT_TYPES.SECTION_TEXT:
      return isMobileView ? theme.custom.fontSize.subsection : theme.custom.fontSize.section;
    case TEXT_TYPES.SECTION_HEADER:
      return isMobileView ? theme.custom.fontSize.primary : theme.custom.fontSize.subsection;
    case TEXT_TYPES.SUBSECTION_TEXT:
      return theme.custom.fontSize.primary;
    default:
      return theme.custom.fontSize.primary;
  }
};

const useFormTextStyles = (type, isMobileView) =>
  makeStyles((theme) => ({
    root: {
      maxWidth: theme.custom.formText.maxWidth,
      marginBottom: addMarginBottom(type, theme, isMobileView),
      color: theme.palette.text.primary,
      fontSize: addFontSize(type, theme, isMobileView),
      fontWeight: addFontWeight(type),
    },
  }));

const FormText = ({ text, type, className }) => {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  const formTextStyles = useFormTextStyles(type, isMobileView)();

  return (
    <>
      {text && (
        <Typography align="left" className={cx(formTextStyles.root, className)} display="block">
          {getTranslation(text)}
        </Typography>
      )}
    </>
  );
};

FormText.propsTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default FormText;
